/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { LocoDetail } from '../../../core/model/loco-detail.model';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';

/**
 * @export
 * @class LmsLocoLastReportedComponent
 * @implements {OnInit}
 * @implements{OnDestroy}
 */
@Component({
  selector: 'lms-loco-last-reported',
  templateUrl: './lms-loco-last-reported.component.html',
  styleUrls: ['./lms-loco-last-reported.component.scss']
})
export class LmsLocoLastReportedComponent implements OnInit, OnDestroy {

  @Input() locoData: LocoDetail;
  @Input() locoLabel: any;
  commonopsPicklist: any;

  /**
   * Creates an instance of LmsLocoLastReportedComponent.
   * @memberOf LmsLocoLastReportedComponent
   */
  constructor(private staticDataStoreService: StaticDataStoreService) { }

  /**
   * @memberOf LmsLocoLastReportedComponent
   */
  ngOnInit() {
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
  }

  /**
   * @memberOf LmsLocoLastReportedComponent
   */
  ngOnDestroy() {
  }

  /**
   * Returns the Full form of Reporting Type
   * @param {string} bestAvailableLocType
   * @returns {string}
   * @memberOf LmsLocoLastReportedComponent
   */
  getReportingTypeValue(bestAvailableLocType: string): string {
    if (bestAvailableLocType) {
      switch (bestAvailableLocType.toUpperCase()) {
        case 'AS':
          return 'Allocation Station Geofence';
        case 'GE':
          return 'Geographic Geofence';
        case 'AE':
          return 'AEI Reporting';
        case 'CU':
          return 'Current Usage';
        case 'CA':
          return 'Current Terminal Assignment';
        case 'TR':
          return 'Location of the current train assignment';
        default:
          return '-';
      }
    }
  }

  /**
   * This method returns dash only when all the values given are null or blank
   * @param {string[]} value
   * @returns
   * @memberOf LmsLocoLastReportedComponent
   */
  returnDash(value: string[]) {
    let isBlank = false;
    for (let i = 0; i < value.length; i++) {
      if (value[i] && value[i].trim()) {
        isBlank = false;
        break;
      } else {
        isBlank = true;
      }
    }
    return isBlank;
  }

  getOprZone(value: string) {
    if (value !== undefined && value !== '') {
      let oprZone = '-';
      if (this.commonopsPicklist && this.commonopsPicklist.setOfTerminals) {
        oprZone = this.commonopsPicklist.setOfTerminals.find(obj => obj.terminalMnemonic === value)
        if (oprZone) {
          oprZone = oprZone['oprZoneName'];
        } else {
          oprZone = '-';
        }
      }
      return oprZone;
    } else {
      return '-';
    }
  }

  getOprRegion(value: string) {
    if (value !== undefined && value !== '') {
      let oprRegion = '-';
      if (this.commonopsPicklist && this.commonopsPicklist.setOfTerminals) {
        oprRegion = this.commonopsPicklist.setOfTerminals.find(obj => obj.terminalMnemonic === value);
        if (oprRegion) {
          oprRegion = oprRegion['oprRegionName'];
        } else {
          oprRegion = '-';
        }
      }
      return oprRegion;
    } else {
      return '-';
    }
  }
}
